<template>
  <div class="directories">
    <!-- <div class="banner">
      <img src="../../assets/banner.png" alt="">
    </div> -->
 
    <div class="directories_content container">
      <div class="directories_title">
        <span class="iconfont iconliebiao"></span>志愿者列表
      </div>
      <div class="directories_list">
        <el-row :gutter="20">
        

           <el-col :xs="8" :md="8" :lg="8" v-for="item in directoriesList" :key="item.id">
            <!-- <div class="list_item">
              <div class="item_left">
                 <img :src="baseurl + (item.header || '/upload/img/%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F.jpg')" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  {{ item.realName }}
                </div>
                <div class="item_right_content e-line-2">
                  {{ item.publishId || '无服务类型' }}
                </div>
              </div>
            </div> -->
             <div class="list_item">
              <div class="item_left">
                 <img :src="baseurl + (item.header || '/upload/header/志愿者头像.png')" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  姓名：{{ item.realName }}
                </div>
                 <div class="item_right_content e-line-1">
                 所属队伍：{{ item.organizationName }}
                </div>
                <div class="item_right_content e-line-2" style="
            height: 40px;" :title="item.publishId">
                  服务类型： {{ item.publishId || '无服务类型' }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="dataform.page"
          :page-size="this.dataform.limit"
          @current-change="handleCurrentChange"
          @prev-click="getdirectoriesList"
          @next-click="getdirectoriesList"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'directories',
  data () {
    return {
      baseurl: this.$baseurl,
      dataform: {
        page: 1,
        limit: 12,
        status: 2,
      },
      total: 0,
      directoriesList: '',
      accountInfo:{

      }
    }
  },
  mounted () {
    this.accountInfo = JSON.parse(localStorage.getItem("accountinfo"))?JSON.parse(localStorage.getItem("accountinfo")):{};
    this.getdirectoriesList()
  },
  methods: {
    handleCurrentChange(v) {
      this.dataform.page = v
      this.getdirectoriesList()
    },
    async getdirectoriesList() {
      let { data: { code, data }} = await this.$http.get('/volunteer/volunteer/page', { params: this.dataform})
      console.log(data);
      if(code != 0) return
      this.directoriesList = data.list
      this.total = data.total
    }
  }
}
</script>

<style lang="scss" scoped>
.directories {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .directories_content {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    .directories_title {
      font-size: 24px;
      line-height: 2;
      .iconliebiao {
        font-size: 28px;
        color: #3498db;
        margin-right: 5px;
      }
    }
    .directories_list { 
      // .list_item {
      //   position: relative;
      //   top: 0;
      //   cursor: pointer;
      //   display: flex;
      //   flex-direction: column;
      //   margin: 10px 0;
      //   border: 2px solid #E4E7ED;
      //   padding: 10px;
      //   border-radius: 7px;
      //   transition: .2s ease-out;
      //  &:hover {
      //     box-shadow: 2px 2px 2px #C0C4CC;
      //     top: -3px
      //   }
      //   .item_left {
      //     margin-right: 10px;
      //     display: flex;
      //     justify-content: center;
      //     align-items: center;
      //     img {
      //       width: 100px;
      //       height: 100px;
      //       object-fit: contain;
      //     }
      //   }
      //   .item_right {
      //     line-height: 1.5;
      //     text-align: center;
      //     .item_right_title {
      //       padding-top: 10px;        
      //       line-height: 2;
      //       font-size: 18px;
      //       font-weight: 500;
      //       color: #303133;
      //     }
      //     .item_right_content {
      //       font-size: 14px;
      //       color: #606266;
      //     }
      //   }
      // }
      .list_item  {
           position: relative;
        top: 0;
        cursor: pointer;
        display: flex;
        margin: 10px 0;
        border: 2px solid #E4E7ED;
        padding: 10px;
        border-radius: 7px;
        transition: .2s ease-out;
          &:hover {
          box-shadow: 2px 2px 2px #C0C4CC;
          top: -3px
        }
        .item_left {
          width: 40%;
          margin-right: 10px;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            height: 100px;
            object-fit: contain;
          }
        }
        .item_right {
          flex: 1;
          line-height: 1.5;
          .item_right_title {
            padding-top: 10px;        
            line-height: 2;
            font-size: 18px;
            font-weight: 500;
            color: #303133;
          }
          .item_right_content {
            font-size: 14px;
            color: #606266;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 30px 0;
    }
  }
  
}
</style>